import axios from 'axios';
import Config from '../../config';
import { MODAL_CLOSE } from '../actions';
import { toast } from 'react-toastify';
import {
    CREATE_YARN_PROJECTION_FAILURE,
    CREATE_YARN_PROJECTION_FORM,
    CREATE_YARN_PROJECTION_REQUEST,
    CREATE_YARN_PROJECTION_SUCCESS,
    DELETE_YARN_PROJECTION_FAILURE,
    DELETE_YARN_PROJECTION_REQUEST,
    DELETE_YARN_PROJECTION_SUCCESS,
    FETCH_YARN_PROJECTION_FAILURE,
    FETCH_YARN_PROJECTION_REQUEST,
    FETCH_YARN_PROJECTION_SUCCESS,
    FETCH_SINGLE_YARN_PROJECTION_FAILURE,
    FETCH_SINGLE_YARN_PROJECTION_REQUEST,
    FETCH_SINGLE_YARN_PROJECTION_SUCCESS,
    RESET_YARN_PROJECTION_INFO,
    UPDATE_YARN_PROJECTION_FAILURE,
    UPDATE_YARN_PROJECTION_REQUEST,
    UPDATE_YARN_PROJECTION_SUCCESS,
    FETCH_PRNO_REQUEST,
    FETCH_PRNO_SUCCESS,
    FETCH_PRNO_FAILURE,
    FETCH_COMBINED_SL_NO_SUCCESS,
    FETCH_COMBINED_SL_NO_FAILURE,
    FETCH_COMBINED_SL_NO_REQUEST,
    FETCH_YARN_PROJECTION_REPORTS_REQUEST,
    FETCH_YARN_PROJECTION_REPORTS_SUCCESS,
    FETCH_YARN_PROJECTION_REPORTS_FAILURE,
    FETCH_YARN_PROJECTION_REPORTS_OVERALL_SUCCESS,
    FETCH_YARN_PROJECTION_REPORTS_OVERALL_FAILURE,
    FETCH_YARN_PROJECTION_REPORTS_OVERALL_REQUEST,
    FETCH_YARN_PROJECTION_OUTSTANDING_REQUEST,
    FETCH_YARN_PROJECTION_OUTSTANDING_SUCCESS,
    FETCH_YARN_PROJECTION_OUTSTANDING_FAILURE,
    //UPDATE_FLD_SUBJECT // subject validations 0407
} from './yarnProjection.actionsType';
import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';
import { fetchCommonPropertyById } from '../property/common/commonProperty.actions';
import { fetchYarnPOSupplierDropdown, fetchYarnPOSupplierDropdown2 } from '../programs/YarnPO/yarnPO/yarnPO.actions';
import { fetchYarnMasterDataDetails } from '../yarnMaster/yarnMaster.action';
import { fetchUnitMaster } from '../unitMaster/unitMaster.actions';


// FETCH PROPERTY MASTER
export let fetchYarnProjection = (startDate, endDate, unitId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnProjectionGET}?FldFKUnitId=${-1}&FldFromDate=${startDate}&FldToDate=${endDate}`,
        responseTypeRequest: FETCH_YARN_PROJECTION_REQUEST,
        responseTypeSuccess: FETCH_YARN_PROJECTION_SUCCESS,
        responseTypeFailure: FETCH_YARN_PROJECTION_FAILURE
    };
    return axiosCall(config);
};


export let fetchYarnProjectionReports = (date) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnProjectionReportsGET}?FldMonthAndYear=${date}`,
        responseTypeRequest: FETCH_YARN_PROJECTION_REPORTS_REQUEST,
        responseTypeSuccess: FETCH_YARN_PROJECTION_REPORTS_SUCCESS,
        responseTypeFailure: FETCH_YARN_PROJECTION_REPORTS_FAILURE
    };
    return axiosCall(config);
};

export let fetchYarnProjectionOutStanding = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnProjectionOutstandingGET}?FldFKUnitId=${-1}`,
        responseTypeRequest: FETCH_YARN_PROJECTION_OUTSTANDING_REQUEST,
        responseTypeSuccess: FETCH_YARN_PROJECTION_OUTSTANDING_SUCCESS,
        responseTypeFailure: FETCH_YARN_PROJECTION_OUTSTANDING_FAILURE
    };
    return axiosCall(config);
};

export let fetchYarnProjectionOverAllReports = (date) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnProjectionReportsOverAllGET}`,
        responseTypeRequest: FETCH_YARN_PROJECTION_REPORTS_OVERALL_REQUEST,
        responseTypeSuccess: FETCH_YARN_PROJECTION_REPORTS_OVERALL_SUCCESS,
        responseTypeFailure: FETCH_YARN_PROJECTION_REPORTS_OVERALL_FAILURE
    };
    return axiosCall(config);
};


export let fetchPrNo = (unitId, supplierId, prDate, prGroup) => {
    const dateObject = new Date(prDate);
    const formattedDate = dateObject.toLocaleDateString('en-US'); // Format date as MM/DD/YYYY


    let currentUrl = prGroup ? `${ConstantApi.yarnProjectionfetchPrNoGET}?FldPRNo=${prGroup}` : `${ConstantApi.yarnProjectionfetchPrNoGET1}?FldFKUnitId=${unitId}&FldFKSupplierId=${supplierId}&FldPRDate=${formattedDate}`

    let config = {
        method: 'get',
        url: currentUrl,
        responseTypeRequest: FETCH_PRNO_REQUEST,
        responseTypeSuccess: FETCH_PRNO_SUCCESS,
        responseTypeFailure: FETCH_PRNO_FAILURE
    };
    return axiosCall(config);
};


export let fetchCombinedSlNo = (prNo) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnProjectionfetchCombinedSlNo}?FldGroupPRNo=${prNo}`,
        responseTypeRequest: FETCH_COMBINED_SL_NO_REQUEST,
        responseTypeSuccess: FETCH_COMBINED_SL_NO_SUCCESS,
        responseTypeFailure: FETCH_COMBINED_SL_NO_FAILURE
    };
    return axiosCall(config);
};

// subject validations 0407
// export const updateFldSubject = (updatedData) => ({
//     type: UPDATE_FLD_SUBJECT,
//     payload: updatedData,
// });



// create user Form
export let createYarnProjectionUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_YARN_PROJECTION_FORM, payload: { key, value } });
    };
};

// CREATE PROPERTY MASTER
export let createYarnProjection = (formData, modalClose, fldFKUnitId, fldFKSupplierID, prDate, prNo, combinedSlNo, stDate, enDate, unitIdall, matchingProjection,) => {
    console.log("formDatassss", prNo);
    let today = new Date();
    let data = JSON.stringify({

        fldId: 0,
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        //fldGroupPRNo: formData.fldGroupPRNo ? formData.fldGroupPRNo : 'Auto Generated' || prNo,
        fldGroupPRNo: prNo,
        fldPRDate: today.toISOString(),
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKMillName: parseInt(formData.fldFKMillName),
        fldMillName: formData.fldMillName,
        fldFKAgentName: parseInt(formData.fldFKAgentName),
        fldAgentName: formData.fldAgentName,
        fldFKYarnGroup: parseInt(formData.fldFKYarnGroup),
        fldYarnGroup: formData.fldYarnGroup,
        fldFKYarnType: parseInt(formData.fldFKYarnType),
        fldYarnType: formData.fldYarnType,
        fldYarnDescription: formData.fldYarnDescription,
        fldBagWeight: formData.fldBagWeight ? Number(formData.fldBagWeight) : 0,
        fldNoofBags: formData.fldNoofBags ? Number(formData.fldNoofBags) : 0,
        fldRate: formData.fldRate ? Number(formData.fldRate) : 0,
        fldPRWeight: Number(formData.fldPRWeight) || 0,
        fldFKYarn: parseInt(formData.fldFKYarn),
        // fldCombinedSlNo: formData.fldCombinedSlNo ? formData.fldCombinedSlNo :"Auto Generated" || 0 ,
        fldCombinedSlNo: parseInt(formData.fldCombinedSlNo) || combinedSlNo,
        fldFKColor: 0,
        fldColor: 'string',
        fldSupplierCode: '',
        fldSupplierName: formData.fldSupplierName,
        fldSupplierAddress1: formData.fldSupplierAddress1,
        fldSupplierAddress2: formData.fldSupplierAddress2,
        fldSupplierFKArea: 0,
        fldSupplierCountry: '',
        fldSupplierState: '',
        fldSupplierCity: formData.fldSupplierCity,
        fldSupplierArea: formData.fldSupplierArea,
        fldSupplierPincode: formData.fldSupplierPincode,
        fldSupplierGSTNo: formData.fldSupplierGSTNo,
        fldSupplierPANNo: '',
        fldSupplierPhoneNo: '',
        fldRemarks: formData.fldRemarks,
        fldBody: formData.fldBody,
        fldSubject: formData.fldSubject,
        fldMonthAndYear: 0,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        fldIsExMillRate: formData.FldIsExMillRate,
        fldIsFabricProjection: formData.fldIsFabricProjection,

    });
    let apiUrl = matchingProjection
        ? `${ConstantApi.yarnProjectionPOST}?fldGroupPRNo=${prNo}`
        : `${ConstantApi.yarnProjectionPOST}`;

    let config = {
        method: 'post',
        data,
        url: apiUrl,
        responseTypeRequest: CREATE_YARN_PROJECTION_REQUEST,
        responseTypeSuccess: CREATE_YARN_PROJECTION_SUCCESS,
        responseTypeFailure: CREATE_YARN_PROJECTION_FAILURE,
        modalClose,
        resetFormData: RESET_YARN_PROJECTION_INFO,
        headers: {
            'Content-Type': 'application/json'
        },
        // let config = {
        //     method: 'post',
        //     data,
        //     url: `${ConstantApi.yarnProjectionPOST}`,
        //     responseTypeRequest: CREATE_YARN_PROJECTION_REQUEST,
        //     responseTypeSuccess: CREATE_YARN_PROJECTION_SUCCESS,
        //     responseTypeFailure: CREATE_YARN_PROJECTION_SUCCESS,
        //     modalClose,
        //     resetFormData: RESET_YARN_PROJECTION_INFO,
        //     headers: {
        //         'Content-Type': 'application/json'
        //     },
        //  getAllData: fetchYarnProjection( stDate, enDate, unitId)
        singlApiArray: [
            fetchPrNo(fldFKUnitId, fldFKSupplierID, prDate),
            fetchCombinedSlNo(prNo),
            fetchYarnProjection(stDate, enDate, unitIdall)
        ]
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleYarnProjection = (userform) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnProjectionGET_SINGLE_USER_ID}/${userform.fldId}`,
        responseTypeRequest: FETCH_SINGLE_YARN_PROJECTION_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_YARN_PROJECTION_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_YARN_PROJECTION_FAILURE,
        singlApiArray: [
            fetchCommonPropertyById(58), // Mill Name
            fetchCommonPropertyById(57), // Agent Name
            // fetchCommonPropertyById(80), //Yarn Material
            //fetchYarnPOSupplierDropdown2('TblProgramSupplier'),
            fetchYarnPOSupplierDropdown('TblYarnPO'),
            fetchYarnMasterDataDetails(),
            fetchUnitMaster(),

        ]
    };
    return axiosCall(config);
};



//UPDATE PROPERTY MASTER
export let updateYarnProjection = (formData, startDate, endDate, unitId) => {
    let today = new Date();
    let data = JSON.stringify({
        ...formData,
        // fldId: parseInt(id),
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        fldGroupPRNo: formData.fldGroupPRNo,
        fldPRDate: formData.fldPRDate,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKMillName: parseInt(formData.fldFKMillName),
        fldMillName: formData.fldMillName,
        fldFKAgentName: parseInt(formData.fldFKAgentName),
        fldAgentName: formData.fldAgentName,
        fldFKYarnGroup: parseInt(formData.fldFKYarnGroup),
        fldYarnGroup: formData.fldYarnGroup,
        fldFKYarnType: parseInt(formData.fldFKYarnType),
        fldYarnType: formData.fldYarnType,
        fldYarnDescription: formData.fldYarnDescription,
        fldBagWeight: formData.fldBagWeight ? Number(formData.fldBagWeight) : 0,
        fldNoofBags: formData.fldNoofBags ? Number(formData.fldNoofBags) : 0,
        fldRate: formData.fldRate ? Number(formData.fldRate) : 0,
        fldPRWeight: Number(formData.fldPRWeight) || 0,
        fldFKYarn: parseInt(formData.fldFKYarn),
        // fldCombinedSlNo: formData.fldCombinedSlNo ? formData.fldCombinedSlNo :"Auto Generated" || 0 ,
        fldCombinedSlNo: parseInt(formData.fldCombinedSlNo),
        fldFKColor: 0,
        fldColor: formData.fldColor,
        fldSupplierCode: '',
        fldSupplierName: formData.fldSupplierName,
        fldSupplierAddress1: formData.fldSupplierAddress1,
        fldSupplierAddress2: formData.fldSupplierAddress2,
        fldSupplierFKArea: 0,
        fldSupplierCountry: '',
        fldSupplierState: '',
        fldSupplierCity: formData.fldSupplierCity,
        fldSupplierArea: formData.fldSupplierArea,
        fldSupplierPincode: formData.fldSupplierPincode,
        fldSupplierGSTNo: formData.fldSupplierGSTNo,
        fldSupplierPANNo: '',
        fldSupplierPhoneNo: '',
        fldRemarks: formData.fldRemarks,
        fldMonthAndYear: 0,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        // fldCreatedBy: 0,
        //fldCreatedDt: today.toISOString(),
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),
        fldIsExMillRate: formData.FldIsExMillRate,
        fldIsFabricProjection: formData.fldIsFabricProjection,

    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.yarnProjectionPATCH}/${formData.fldId}`,
        responseTypeRequest: UPDATE_YARN_PROJECTION_REQUEST,
        responseTypeSuccess: UPDATE_YARN_PROJECTION_SUCCESS,
        responseTypeFailure: UPDATE_YARN_PROJECTION_FAILURE,
        resetFormData: RESET_YARN_PROJECTION_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchYarnProjection(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteYarnProjection = (id, startDate, endDate, unitId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.yarnProjectionDELETE}/${id}`,
        responseTypeRequest: DELETE_YARN_PROJECTION_REQUEST,
        responseTypeSuccess: DELETE_YARN_PROJECTION_SUCCESS,
        responseTypeFailure: DELETE_YARN_PROJECTION_FAILURE,
        modalClose: true,
        getAllData: fetchYarnProjection(startDate, endDate, unitId)
    };
    return axiosCall(config);
};
